<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Delete {{name}}?</modal-header>
        </div>
        Are you sure you want to delete this Render?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import { monitorMixin } from '@/mixins/monitorMixin'
import { renderMixin } from '@/mixins/renderMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal-render-bot-delete-confirm',
  mixins: [modalMixin, notificationMixin, renderMixin, monitorMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    type: String,
    name: String,
    confirmId: String
  },
  methods: {
    confirm () {
      this.startLoading()
      this.deleteRenderBot(this.confirmId).then(() => {
        this.getRenderBots().then(() => {
          this.finishLoading()
          this.addNotification('success', `Data has been deleted.`)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/render-bot/modal-render-bot-delete-confirm.vue